import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaHome } from 'react-icons/fa';

const NotFound = () => {
    return (
        <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
            <Row>
                <Col className="text-center">
                    <h1 className="display-1 fw-bold text-primary">404</h1>
                    <h2 className="mb-4">Page Not Found</h2>
                    <p className="text-muted mb-4">
                        The page you are looking for doesn't exist or has been moved.
                    </p>
                    <Link to="/dashboard" className="btn btn-primary">
                        <FaHome className="me-2" />
                        Go to Dashboard
                    </Link>
                </Col>
            </Row>
        </Container>
    );
};

export default NotFound;
